export default class SeasonalIndicatorCalednar {
    constructor(seasonal = {}, idCalendar){
        this.indicatorId = seasonal.indicatorId ? seasonal.indicatorId : 0;
        this.calendarId = idCalendar;
        this.indicatorName = seasonal.indicatorName ? seasonal.indicatorName :0;
        this.link = seasonal.link ? seasonal.link : false;
        this.productionUnitId = seasonal.productionUnitId ? seasonal.productionUnitId :0;
        this.system = seasonal.system ? seasonal.system :0;
    }
}